import { fromJS } from 'immutable';
import { ACTION } from './constants';

const initialState = {
};

function manualGradeConfigurationReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case ACTION.AUTHOR_MANUAL_GRADING_CONFIGURATION_PUT:
      return state
        .set(action.componentId, { maxScore: action.maxScore, componentId: action.componentId, isEnabled: action.isEnabled });
    default:
      return state;
  }
}

export {
  initialState,
};

export default manualGradeConfigurationReducer;
